import { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearNotification } from '../../reduser/notificationSlice';
import axios from 'axios';
import { Container } from "react-bootstrap";
import Button from '../CustomButton/Button'
import InputMask from 'react-input-mask';
import './register.css'
import host from "../../host";
import { showNotification } from '../../utils/notificationUtils';



function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [step, setStep] = useState(1);
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const notification = useSelector(state => state.notification);

  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        dispatch(clearNotification());
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [notification, dispatch]);


  const sendPhone = () => {
    const correct_phone = phone.replace(/[^0-9+]/g, '')
    if (correct_phone.length === 13) {
      axios
        .post(
          `${host}api/send-sms/`,
          {
            phone_number: correct_phone,
          },
          {
            withCredentials: true
          }
        )
        .then((response) => {
          if (response.status === 200) {
            setError('')
            setStep(2);
            showNotification(dispatch, 'На ваш номер отправлено смс с кодом', 'success');
          }
        })
        .catch((error) => {
          if (error.response.status === 429) {
            showNotification(dispatch, 'Разрешено не более 1 смс в минуту', 'error');
          }
          if (error.response?.data?.phone_number) {
            showNotification(dispatch, 'Этот телефон уже зарегистрирован', 'error');
          } else {
          }
        });
    } else {
      showNotification(dispatch, 'Номер не корректен', 'error');
    }
  };


  const verifyCode = () => {
    if (code.length === 5) {
      axios
        .post(`${host}api/check-code/`,
          {
            code: code,
          },
          {
            withCredentials: true
          }
        )
        .then((response) => response.status)
        .then((status) => {
          setError('')
          setStep(3);
        })
        .catch((error) => {
          showNotification(dispatch, 'Код не верный', 'error');
        });
    } else {
      showNotification(dispatch, 'Код должен состоять из 5 цифр', 'error');
    }
  };


  const submitRegister = async () => {
    if (password === password2) {
      if (username.length === 5) {

        try {
          const registerResponse = await axios.post(`${host}api/register/`, {
            username: username,
            password: password,
          }, {
            withCredentials: true
          });

          if (registerResponse.status === 201) {
            showNotification(dispatch, 'Успешно! Ожидайте активации вашей записи', 'success');
            navigate('/note');

          } else if (registerResponse.status === 400) {
          }
        } catch (error) {
          if (error.response && error.response.data) {
            if (error.response.data.message) {
              showNotification(dispatch, 'Пользователь уже существует', 'error');
            }

            if (error.response.data.username) {
              setError(error.response.data.username[0]);
            }
          } else {
          }
        }
      }
      else {
        showNotification(dispatch, 'Табельный должен содержать 5 цифр', 'error');
      }
    } else {
      showNotification(dispatch, 'Пароли не совпадают', 'error');
    }
  };

  return (
    <Container fluid className="cont-lg d-flex justify-content-center align-items-center">
      {error && <div className="alert alert-danger" role="alert">{error}</div>}
      {step === 1 && (
        <Form className="form-container shadow-lg p-4 rounded" onSubmit={(e) => {
          e.preventDefault();
          sendPhone(phone);
        }}>
          <Form.Group className="mb-3" controlId="formBasicPhone">
            <Form.Label className='help-login-text text-center form-hint'>Введите номер мобильного телефона к которому будет привязан ваш аккаунт</Form.Label>
            <InputMask
              mask="+375 (99) 999-99-99"
              value={phone}
              onChange={e => setPhone(e.target.value)}
            >
              {() => (
                <Form.Control
                  type="tel"
                  placeholder="Номер мобильного телефона"
                />
              )}
            </InputMask>

            <Button type="submit" className="btn-outline" style={{ marginTop: 10, width: '100%' }}>
              Отправить
            </Button>
          </Form.Group>
        </Form>
      )}

      {step === 2 && (
        <Form className="form-container shadow-lg p-4 rounded" onSubmit={(e) => {
          e.preventDefault();
          verifyCode(code)
        }}>
          <Form.Group className="mb-3" controlId="formBasicCode">
            <Form.Label className='form-hint'>Введите код из смс сообщения</Form.Label>
            <Form.Control type="code" placeholder="Код из смс" value={code}
              onChange={e => setCode(e.target.value)} />
            <Button type="submit" className="btn-outline" style={{ marginTop: 20, width: '100%' }} >
              Проверить
            </Button>
          </Form.Group>
        </Form>
      )}

      {step === 3 && (
        <>
          <Form className="form-container shadow-lg p-4 rounde" onSubmit={(e) => {
            e.preventDefault();
            submitRegister(username, password, password2)
          }}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Табельный номер</Form.Label>
              <Form.Control type="num" placeholder="Введите табельный номер" value={username}
                onChange={e => setUsername(e.target.value)} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Пароль</Form.Label>
              <Form.Control type="password" placeholder="Введите пароль" value={password}
                onChange={e => setPassword(e.target.value)} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword1">
              <Form.Label>Пароль еще раз</Form.Label>
              <Form.Control type="password" placeholder="Введите пароль еще раз" value={password2}
                onChange={e => setPassword2(e.target.value)} />
            </Form.Group>
            <Button type="submit" className="btn-outline" style={{ marginTop: 20, width: '100%' }}>
              Регистрация
            </Button>
          </Form>
        </>
      )}
    </Container>
  );
}

export default Login;